import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { debounce } from "@mui/material/utils";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import TimeTable from "../time-table/TimeTable";
import { toTimeRows } from "../time-table/timeTableSlice";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { SerializedError } from "../../util/types";
import Metadata from "../metadata/Metadata";
import MDViewer from "../markdown/Markdown";
import {
    Ticket,
    TicketItem,
    TicketEditRequest,
    selectTicket,
    selectChildrenItems,
    toEditRequest,
} from "./ticketSlice";
import {
    useTicketViewQuery,
    useTicketParentQuery,
    TicketItemsResponse,
} from "../../api/ticket";
import TicketEditDisplay from "./TicketEditDisplay";
import TicketPaneViewer from "./TicketPaneViewer";
import { ToolBar } from "./RightToolBar";

const vcontentStyle = {
    height: "100%",
    width: "100%",
    margin: 0,
    display: "flex",
    //backgroundColor: 'pink',
};
const contentStyle = {
    height: "100%",
    width: "100%",
    margin: 0,
    //overflow: 'auto',
    display: "flex",
    //backgroundColor: 'grey',
};
const colOneStyle = {
    height: "100%",
    flexGrow: 4,
    width: "50%",
    //backgroundColor: '#eeeeee',
    //overflow: 'auto',
};
const colTwoStyle = {
    height: "100%",
    flexGrow: 4,
    //backgroundColor: 'green',
    width: "50%",
    //overflow: 'auto',
};
const viewStyle = {
    height: `calc(100% - 44px)`,
    overflow: "auto",
    padding: 2,
    width: "100%",
    //height: '100%r',
    //backgroundColor: 'purple',
};

interface QueryPropsNullable {
    id: string | null;
    childType: string | null;
    onChange: (value: string | null) => void;
}

interface QueryProps {
    id: string;
    childType: string | null;
    onChange: (value: string | null) => void;
}

const initialOptions = ["Opt 1", "Opt 2"];

export default function ParentComplete({
    id,
    childType,
    onChange,
}: QueryPropsNullable) {
    const [ctype, setCType] = React.useState<string | null>(childType);
    if (childType !== ctype) {
        setCType(childType);
    }
    if (id) {
        return (
            <ParentFetchComplete
                id={id}
                childType={ctype}
                onChange={onChange}
            />
        );
    } else {
        return (
            <ParentCompleteSuccess
                parent={null}
                childType={ctype}
                onChange={onChange}
            />
        );
    }
}

export function ParentFetchComplete({ id, childType, onChange }: QueryProps) {
    const [ctype, setCType] = React.useState<string | null>(childType);
    if (childType !== ctype) {
        setCType(childType);
    }
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useTicketViewQuery(id);
    let content: React.ReactNode;
    if (isLoading) {
        content = <TicketViewerFetching />;
    } else if (isFetching) {
        content = <TicketViewerFetching />;
    } else if (isSuccess) {
        //console.log("202411131337", data);
        let parent = data.ticket ? data.ticket : null;
        content = (
            <ParentCompleteSuccess
                parent={parent}
                childType={ctype}
                onChange={onChange}
            />
        );
    } else if (isError) {
        content = <TicketViewerError error={error} />;
    }
    return <Box>{content}</Box>;
}

interface PCProps {
    parent: TicketItem | null;
    childType: string | null;
    onChange: (id: string | null) => void;
}

function ti_map_to_ti_list(
    parent: TicketItem | null,
    items: { [key: string]: TicketItem },
): (TicketItem | null)[] {
    let result: (TicketItem | null)[] = [parent];
    for (const key in items) {
        if (!parent || (parent && parent.metadata.id !== key)) {
            result.push(items[key]);
        }
    }

    return result;
}

export function XParentCompleteSuccess({
    parent,
    childType,
    onChange,
}: PCProps) {
    return <Box>Ok</Box>;
}
export function ParentCompleteSuccess({
    parent,
    childType,
    onChange,
}: PCProps) {
    const initialOptions = parent ? [parent] : [];
    const [ctype, setCType] = React.useState<string | null>(childType);
    const [value, setValue] = React.useState<TicketItem | null>(
        parent ? parent : null,
    );
    const [inputValue, setInputValue] = React.useState(
        parent ? parent.title : "",
    );
    const [debouncedInput, setDebouncedInput] = useState(
        parent ? parent.title : "",
    );
    //const [options, setOptions] = React.useState<(TicketItem | null)[]>(initialOptions);
    if (childType !== ctype) {
        setCType(childType);
    }
    //console.log("202411191023 autocomplete start value", value);
    //console.log("202411191023 autocomplete start inputValue", inputValue);
    //console.log("202411191023 autocomplete start childType", ctype);
    //console.log("202411191023 autocomplete start debounce", debouncedInput);
    const sameParent = parent && parent.title === inputValue ? true : false;
    const selectedValue = React.useMemo(() => value, [value]);
    const mInputValue = React.useMemo(() => inputValue, [inputValue]);
    const changed = React.useMemo(() => inputValue, [inputValue]);
    // Debounce the input changes
    /*
	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedInput(inputValue);
		}, 2000); // Wait 300ms before updating

		return () => {
			clearTimeout(handler);
		};
	}, [inputValue]);
    // */
    //*
    //useEffect(() => {
    //	console.log("202411150809 input value", inputValue);
    const { data, isLoading, isFetching, isSuccess, isError, error } =
        useTicketParentQuery(
            { ktype: childType ? childType : "", inputValue: inputValue },
            {
                //} = useTicketParentQuery({ktype: childType ? childType : "", inputValue: debouncedInput}, {
                //skip: (debouncedInput.length < 3 || debouncedInput === inputValue),
                skip: inputValue.length < 3,
            },
        );
    /*
		if (isSuccess) {
			let til = ti_map_to_ti_list(data.ticket_items);
			console.log("202411182258 is success", til);
			setOptions(til);
		}
		// */
    //}, [inputValue]);
    // */
    const options = React.useMemo(() => {
        if (data) {
            return ti_map_to_ti_list(parent, data.ticket_items);
        } else {
            return [];
        }
    }, [data]);
    return (
        <Autocomplete
            value={selectedValue}
            loading={isLoading || isFetching}
            onChange={(event: any, newValue: TicketItem | null) => {
                console.log(
                    "202411150809 autocomplete onchange value",
                    newValue,
                );
                setValue(newValue);
                onChange(newValue ? newValue.metadata.id : null);
                //setValue(null);
            }}
            inputValue={mInputValue}
            onInputChange={React.useCallback(
                (event: React.SyntheticEvent, newInputValue: string) => {
                    console.log("202411191021 autocomplete", newInputValue);
                    setInputValue(newInputValue);
                },
                [],
            )}
            id="parent-id"
            options={options}
            getOptionLabel={(option: TicketItem | null) => {
                return option ? option.title + " (" + option.ktype + ")" : "";
            }}
            getOptionKey={(option: TicketItem | null): string =>
                option && option.metadata.id ? option.metadata.id : ""
            }
            isOptionEqualToValue={(
                option: TicketItem | null,
                value: TicketItem | null,
            ) => {
                if (option && value) {
                    if (option.metadata.id === value.metadata.id) return true;
                }
                if (!option && !value) {
                    return true;
                }
                return false;
            }}
            renderInput={(params) => (
                <TextField {...params} label="controllable" />
            )}
            filterOptions={(x) => x}
        />
    );
}

export function TicketViewerFetching() {
    return <Box>Fetching</Box>;
}

export function TicketViewerError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <Box>Error</Box>;
}
